import colors from "./abstracts/variables/_colors.scss";

export default colors;
